module.exports = __webpack_public_path__ + "static/img/07056C_1_2_C_20210523_fit.3f7dc5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/07056C_1_2_C_20210523_fit.png
// module id = knsD
// module chunks = 0